<template>
  <v-row>
    <v-col md="5">
      <v-card class="result-card">
        <p class="card-title mb-8">{{ $t("Test.personal_data") }}</p>
        <v-row>
          <v-col md="5">
            <span>{{ $t("Employee.fio") }}:</span>
          </v-col>
          <v-col md="7" class="d-flex align-center">
            <span>
              {{ currentTest.last_name ? currentTest.last_name + " " : "" }}
            </span>
            <span>{{
              currentTest.first_name ? currentTest.first_name + " " : " "
            }}</span>
            <span>{{
              currentTest.middle_name ? currentTest.middle_name : " "
            }}</span>
          </v-col>
          <v-col md="5">
            <span>{{ $t("Default.birth_date") }}:</span>
          </v-col>
          <v-col md="7">
            <span>{{ getValueOrDefault(currentTest.date_of_birth)}}</span>
          </v-col>
          <v-col md="5">
            <span>{{ $t("Default.gender") }}:</span>
          </v-col>
          <v-col md="7">
            <template v-if="typeof currentTest.gender === 'number'">
              <span v-if="currentTest.gender === 0">{{ $t("Default.woman") }}</span>
              <span v-if="currentTest.gender === 1">{{ $t("Default.man") }}</span>
            </template>
            <template v-else>
              {{$t("Default.not_filled")}}
            </template>
          </v-col>
          <v-col md="5">
            <span> {{ $t("Default.hobby") }}: </span>
          </v-col>
          <v-col md="7">
            {{ getValueOrDefault(currentTest.hobbies) }}
          </v-col>
          <v-col md="5">
            <span>{{ $t("Default.position_job") }}:</span>
          </v-col>
          <v-col md="7">
            {{ getValueOrDefault(currentTest.job_title) }}
          </v-col>
          <v-col md="5">
            <span>{{ $t("Default.mail") }}:</span>
          </v-col>
          <v-col md="7">
            {{ currentTest.email }}
          </v-col>
          <v-col md="5">
            <span>{{ $t("Default.number") }}:</span>
          </v-col>
          <v-col md="7">
            {{ getValueOrDefault(formatPhoneDisplay(currentTest.phone_number)) }}
          </v-col>
        </v-row>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import {computed, defineComponent, ref} from "@vue/composition-api";
import { formatPhoneDisplay } from "@/utility/helpers";

export default defineComponent({
  props: ["currentTest"],
  setup(props, { root }) {
    const notFilled = computed(() => root.$i18n.t("Default.not_filled"))
    const getValueOrDefault = (value) => {
      return !!value ? value : notFilled.value
    }
    console.log(props.currentTest)
    return {
      getValueOrDefault,
      formatPhoneDisplay,
    };
  },
});
</script>

<style></style>
